/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateSortContactSettingRequestContactSettingsInner,
  UpdateSortContactSettingRequestContactSettingsInnerFromJSON,
  UpdateSortContactSettingRequestContactSettingsInnerFromJSONTyped,
  UpdateSortContactSettingRequestContactSettingsInnerToJSON
} from './UpdateSortContactSettingRequestContactSettingsInner'

/**
 *
 * @export
 * @interface UpdateSortContactSettingRequest
 */
export interface UpdateSortContactSettingRequest {
  /**
   *
   * @type {Array<UpdateSortContactSettingRequestContactSettingsInner>}
   * @memberof UpdateSortContactSettingRequest
   */
  contactSettings?: Array<UpdateSortContactSettingRequestContactSettingsInner>
}

export function UpdateSortContactSettingRequestFromJSON(json: any): UpdateSortContactSettingRequest {
  return UpdateSortContactSettingRequestFromJSONTyped(json, false)
}

export function UpdateSortContactSettingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSortContactSettingRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contactSettings: !exists(json, 'contact_settings')
      ? undefined
      : (json['contact_settings'] as Array<any>).map(UpdateSortContactSettingRequestContactSettingsInnerFromJSON)
  }
}

export function UpdateSortContactSettingRequestToJSON(value?: UpdateSortContactSettingRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact_settings:
      value.contactSettings === undefined
        ? undefined
        : (value.contactSettings as Array<any>).map(UpdateSortContactSettingRequestContactSettingsInnerToJSON)
  }
}
